import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Body2 } from 'components/Typography';
import { Icon } from '@dapp/multi-lib/sdaoui/Icon';
import { Surface } from '@dapp/multi-lib/sdaoui/Surface';
import { VaultIdentity } from 'structure/pv2/vault/utils/vault';
import { useVault } from 'structure/pv2/vault/hooks/useVault';
import { appConfig } from 'utils/app.config';

interface VaultFeeInfoProps {
  vaultIdentity: VaultIdentity;
}

export const VaultFeeInfo = (props: VaultFeeInfoProps) => {
  const { vaultIdentity } = props;
  const { t } = useTranslation('vault');
  const vaultQuery = useVault(vaultIdentity);

  if (vaultQuery.isLoading || !vaultQuery.data) {
    return null;
  }

  const redirectToFees = () => {
    window.open(appConfig.dynaVaults.whatAreFees, '_blank');
  };

  const normalisedPerformanceFee = (value: string) => {
    return Number(value) * 100;
  };

  return (
    <div className='flex flex-col gap-6'>
      <Surface className='flex justify-between bg-black-800 lg:flex-row'>
        <div className='lg:gap-15 flex flex-col gap-1 text-white lg:flex-row'>
          {vaultQuery.data.fees.map((fee) => {
            return (
              <Body2 key={fee.key} className='text-inherit'>
                {fee.title}: {normalisedPerformanceFee(fee.percentage)}%
              </Body2>
            );
          })}
        </div>
        {appConfig.dynaVaults.whatAreFees && (
          <div className='text-white-400'>
            <div
              onClick={redirectToFees}
              className='flex cursor-pointer flex-row items-center gap-1'
            >
              <Body2 className='text-inherit'>{t('WHAT_ARE_FEES')}</Body2>
              <Icon icon='school' width={20} height={20} />
            </div>
          </div>
        )}
      </Surface>

      {/* <Surface className='flex flex-col bg-black-800 lg:flex-row'>
        <div className='flex flex-col gap-2'>
          <Body2>{t('REVENUE_GENERATED_FOR_DAO_PARTICIPANTS')}</Body2>
          <Body2 className='text-[0.75rem] leading-[1.125rem] text-green'>
            Na
          </Body2>
          <UsdValue size='small' color='green' value={12000} />
        </div>
        <div className='ml-auto'>
          <Button size={isMobile ? 'small' : 'medium'}>
            {t('BECOME_A_PARTICIPANT')}
          </Button>
        </div>
      </Surface> */}
    </div>
  );
};
